import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

const AnimatedCounter = ({
  value,
  duration = 2,
  prefix = "",
  suffix = "",
  decimals = 0,
  color = "#1976d2",
  size = "h4",
}) => {
  const [displayValue, setDisplayValue] = useState(0);

  useEffect(() => {
    let startTime = null;
    const startValue = 0;
    const endValue = parseFloat(value);

    const animate = (currentTime) => {
      if (startTime === null) startTime = currentTime;
      const progress = Math.min(
        (currentTime - startTime) / (duration * 1000),
        1
      );

      const currentValue = startValue + (endValue - startValue) * progress;
      setDisplayValue(currentValue);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [value, duration]);

  return (
    <motion.div
      initial={{ scale: 0.8, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5 }}
      style={{ color }}
    >
      <motion.span
        key={displayValue}
        initial={{ y: 20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.3 }}
        style={{
          fontSize:
            size === "h1"
              ? "2.5rem"
              : size === "h2"
              ? "2rem"
              : size === "h3"
              ? "1.75rem"
              : "1.5rem",
          fontWeight: 700,
          fontFamily: "Inter, sans-serif",
        }}
      >
        {prefix}
        {displayValue.toFixed(decimals)}
        {suffix}
      </motion.span>
    </motion.div>
  );
};

export default AnimatedCounter;


